import { createSelector } from '@ngrx/store';
import { selectPopupsState } from '../reducers';
import { Popups, PopupsDTO } from '../../commons/models/popups';
import { PopupState } from '../reducers/popups.reducers';

export const getPopupsTableState = createSelector(
    selectPopupsState,
  (state: PopupState) => { return { total: state.total, currentPage: state.currentPage, perPage: state.perPage, order: state.order, direction: state.direction, filters: state.filters, includes: state.includes } }
);

export const getPopups = createSelector(
    selectPopupsState,
  (state: PopupState) => state.list
);

export const getTotalPopups = createSelector(
    getPopupsTableState,
  (tableState) => tableState.total
);

export const getPopupsCurrentPage = createSelector(
    getPopupsTableState,
  (tableState) => tableState.currentPage
);

export const getPopupsPerPage = createSelector(
    getPopupsTableState,
  (tableState) => tableState.perPage
);

export const getPopupsDirection = createSelector(
    getPopupsTableState,
    (tableState) => tableState.direction
);

export const getFilters = createSelector(
    getPopupsTableState,
  (tableState) => tableState.filters
);

export const getPopupDialogId = createSelector(
    selectPopupsState,
  (state: PopupState) => state.dialogId
);

export const getSelectionDialogId = createSelector(
    selectPopupsState,
  (state: PopupState) => state.selectionDialogId
);

export const getSelectedPopupsCurrentPage = createSelector(
    selectPopupsState,
  (state: PopupState) => {
    const selection = (state.selectedPopups || []).map(bl => bl.id);
    return state.list?.filter(bl => selection.includes(bl.id));
  }
);